module.exports = __webpack_public_path__ + "img/case_1.1cca185b.png";